module.exports = __webpack_public_path__ + "img/1.2216eaa2.jpg";